import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import axios from "axios";
import StandardButton from "@/components/buttons/StandardButton.vue";
import WTinyMce from "@/components/wrappers/w-tiny-mce.vue";
import { Component, Prop, Vue } from "vue-facing-decorator";
import WElmessage from "@/components/wrappers/w-elmessage.vue";
let AccessibilityStatementEditVue = class AccessibilityStatementEditVue extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "isAdmin", void 0);
    _defineProperty(this, "accessibilityData", null);
    _defineProperty(this, "editorConfig", null);
  }
  mounted() {
    this.getAccessibilityDataAndBuildEditorConfig();
  }
  getAccessibilityDataAndBuildEditorConfig() {
    axios.get('/api/v2/accessibility-data').then(({
      data
    }) => {
      this.accessibilityData = data;
    }).catch(error => {
      if (this.isAdmin && error.response?.status === 404) {
        this.accessibilityData = {
          statement: this.$t("accessibility.statement.edition.placeholder")
        };
      }
    }).finally(() => {
      if (this.accessibilityData) {
        this.editorConfig = this.buildEditorConfig();
      }
    });
  }
  buildEditorConfig() {
    return {
      style_formats: [{
        title: 'H1',
        format: 'h1'
      }, {
        title: 'H2',
        format: 'h2'
      }, {
        title: 'H3',
        format: 'h3'
      }],
      height: '70vh',
      allowFullScreenExpand: true
    };
  }
  saveAccessibilityData(accessibilityStatement) {
    if (accessibilityStatement) {
      const data = {
        statement: accessibilityStatement
      };
      this.accessibilityData?.id ? this.putData(this.accessibilityData.id, data) : this.postData(data);
    }
  }
  postData(data) {
    axios.post('/api/v2/accessibility-data', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(() => {
      this.onSaveSuccess();
    }, _ => {
      WElmessage.showErrorMessage(this.$t('accessibility.statement.edition.on-save.error'));
    });
  }
  putData(id, data) {
    axios.put(`/api/v2/accessibility-data/${id}`, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(() => {
      this.onSaveSuccess();
    }, _ => {
      WElmessage.showErrorMessage(this.$t('accessibility.statement.edition.on-save.error'));
    });
  }
  onSaveSuccess() {
    WElmessage.showSuccessMessage(this.$t('accessibility.statement.edition.on-save.success'));
    this.redirectTo("/accessibility-statement");
  }
  cancelEdit() {
    this.redirectTo("/");
  }
  redirectTo(path) {
    window.location.assign(path);
  }
};
__decorate([Prop({
  default: false
})], AccessibilityStatementEditVue.prototype, "isAdmin", void 0);
AccessibilityStatementEditVue = __decorate([Component({
  components: {
    WTinyMce,
    StandardButton
  }
})], AccessibilityStatementEditVue);
export default AccessibilityStatementEditVue;